/*
 * SPARE DRIVER LOGIC REMOVED 7/14/2022 PER RICK
 *
 */
import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";

import { useApolloClient } from "react-apollo";

import { Field, Control, Button, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import moment from "moment";
// import gql from "graphql-tag";
import { BookingCodeSelect } from "../../../components/inputs";
import { AddBookingForm, EditBookingForm } from "../../../components/Bookings";
import { ModalContext } from "../../../components/ModalProvider";
import { getUTCFormattedDate } from "../../../utils";
// import { useSystemCodes } from "../../../utils/hooks";

import { CREATE_BOOKING_MUTATION } from "../../../graphql/Bookings/Bookings.graphql";

import { UPDATE_ORDER_MUTATION } from "../../../graphql/Orders/Orders.graphql";

// const SINGLE_EMPLOYEE_QUERY = gql`
//   query Employee($where: EmployeeWhereUniqueInput!) {
//     Employee(where: $where) {
//       RecId
//       EmployeeTypeRecIdRef
//     }
//   }
// `;

const BookingCodeInput = ({
  where = {},
  data: initialState = {},
  currentUser = {},
  pickupDate = "",
  fetchData = () => {},
  disabled = false,
  onChange,
  orders,
  filterBooked = false,
  isBookable = true,
  showDuplicate = false
}) => {
  const client = useApolloClient();
  const [state, setState] = useState({});
  // const [isSpareDriver, setIsSpareDriver] = useState(false);

  // const { data: employeeSysCodes } = useSystemCodes({
  //   CodeName: "EmployeeType",
  //   CodeId: "S"
  // });

  // const { data: bookingSysCodes } = useSystemCodes({
  //   CodeName: "BookCatg",
  //   CodeId: "NA-PTO"
  // });

  // const spareDriverRecId = employeeSysCodes?.[0]?.RecId;
  // const ptoCodeRecId = bookingSysCodes?.[0]?.RecId;

  // Removed Per Rick 7/14/2022

  // useEffect(() => {
  //   if (spareDriverRecId && state.EmployeeRecIdRef) {
  //     const getEmployee = async () => {
  //       const {
  //         data: { Employee = {} }
  //       } = await client.query({
  //         query: SINGLE_EMPLOYEE_QUERY,
  //         variables: { where: { RecId: parseInt(state.EmployeeRecIdRef) } }
  //       });
  //       setIsSpareDriver(Employee?.EmployeeTypeRecIdRef === spareDriverRecId);
  //     };
  //     getEmployee();
  //   }
  // }, [client, spareDriverRecId, state.EmployeeRecIdRef]);

  const { setModalOpen } = useContext(ModalContext);

  const handleBookingCodeChange = async newValue => {
    setState(prev => ({ ...prev, BookingCodeRecIdRef: newValue }));

    const {
      data: { createBooking }
    } = await client.mutate({
      mutation: CREATE_BOOKING_MUTATION,
      variables: {
        data: {
          EmployeeRecIdRef: parseInt(state.EmployeeRecIdRef),
          BookingCodeRecIdRef: parseInt(newValue),
          BookingDate: getUTCFormattedDate(),
          OperatorRecIdRef: currentUser.RecId,
          PickupDate: getUTCFormattedDate(
            new Date(pickupDate).getTime() + 1000 * 60 * 60 * 4
          )
        }
      }
    });
    if (Array.isArray(orders)) {
      await Promise.all(
        orders.map(order =>
          client.mutate({
            mutation: UPDATE_ORDER_MUTATION,
            variables: {
              data: {
                BookingRecIdRef: createBooking.RecId
              },
              where: {
                RecId: order.RecId
              }
            }
          })
        )
      );
    }
    await fetchData();
    if (onChange) {
      onChange({ target: { name: "BookingCodeRecIdRef", value: newValue } });
    }
  };
  useEffect(() => {
    if (initialState) {
      setState(initialState);
    }
  }, [initialState]);

  const handleComplete = (refetch = true) => {
    setModalOpen(false, "");
    if (refetch) {
      fetchData();
    }
  };

  const handleClone = () => {
    handleBookingCodeChange(state.BookingCodeRecIdRef);
  };

  const handleOpenModal = () => {
    setModalOpen(
      true,
      state.BookingRecIdRef ? (
        <EditBookingForm
          bookingCodeWhere={
            where
            // isSpareDriver && ptoCodeRecId
            //   ? { ...where, CodeCatgRecIdRef_not: ptoCodeRecId }
            //   : where
          }
          isBookable={isBookable}
          state={{
            RecId: state.BookingRecIdRef,
            EmployeeRecIdRef: state.EmployeeRecIdRef,
            OperatorRecIdRef: state.Booking.OperatorRecIdRef,
            BookingCodeRecIdRef: state.BookingCodeRecIdRef,
            Comment: state.Booking.Comment,
            PickupDate: state.Booking.PickupDate,
            BookingDate: new Date(
              state.Booking.BookingDate
            ).toCorrectDateString(),
            BookingStartDate: state.Booking.PickupDate,
            BookedTrip: state.BookedTrip || state.Booking.BookedTrip,
            CreatedDateTime: state.Booking.CreatedDateTime
          }}
          onComplete={handleComplete}
        />
      ) : (
        <AddBookingForm
          bookingCodeWhere={
            where
            // isSpareDriver && ptoCodeRecId
            //   ? { ...where, CodeCatgRecIdRef_not: ptoCodeRecId }
            //   : where
          }
          isBookable={isBookable}
          state={{
            EmployeeRecIdRef: state.EmployeeRecIdRef,
            OperatorRecIdRef: currentUser.RecId,
            BookingCodeRecIdRef: state.BookingCodeRecIdRef,
            PickupDate: pickupDate,
            BookingStartDate: moment(pickupDate).format("YYYY-MM-DD"),
            BookedTrip: state.BookedTrip,
            CreatedDateTime: moment().format("MM/DD/YY, hh:mm")
          }}
          onComplete={handleComplete}
        />
      )
    );
  };

  return (
    <Field kind="addons">
      <Control>
        <BookingCodeSelect
          defaults={{ label: "", value: 0 }}
          disabled={disabled}
          filterBooked={filterBooked}
          icon="circle"
          isBookable={isBookable}
          name="BookingCodeRecIdRef"
          value={state.BookingCodeRecIdRef}
          where={
            where
            // isSpareDriver && ptoCodeRecId
            //   ? { ...where, CodeCatgRecIdRef_not: ptoCodeRecId }
            //   : where
          }
          onChange={({ target: { value } }) => handleBookingCodeChange(value)}
        />
      </Control>
      <Control>
        <Button
          color="link"
          disabled={disabled}
          style={{ padding: 0, width: 40 }}
          title="Booking Code Detail"
          onClick={() => {
            handleOpenModal();
          }}
        >
          <Icon size="small">
            <FontAwesomeIcon icon="book-open" size="xs" />
          </Icon>
        </Button>
      </Control>
      {showDuplicate && (
        <Control>
          <Button
            color="primary"
            disabled={disabled}
            style={{ padding: 0, width: 40 }}
            title="Duplicate"
            onClick={handleClone}
          >
            <Icon size="small">
              <FontAwesomeIcon icon="clone" size="xs" />
            </Icon>
          </Button>
        </Control>
      )}
    </Field>
  );
};

BookingCodeInput.propTypes = {
  where: PropTypes.object,
  data: PropTypes.object,
  currentUser: PropTypes.object,
  pickupDate: PropTypes.string,
  fetchData: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  orders: PropTypes.array,
  filterBooked: PropTypes.bool,
  isBookable: PropTypes.bool,
  showDuplicate: PropTypes.bool
};
export default BookingCodeInput;
